export const FilmGrain = () => (
  <div className="grain-overlay" aria-hidden="true" data-testid="film-grain-overlay" />
);
